module.exports = __webpack_public_path__ + "img/info-item-1.2512bdd8.png";